<template>
    <div class="flat-account-components">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Member.revenueflow.balancing')" left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-position="right"
                label-width="120px"
                label-suffix=":">
                <el-form-item :label="$t('Common.store')">
                    <el-select
                        v-model="form.storeId"
                        style="width: 180px;"
                        :placeholder="$t('Common.store_placeholder')">
                        <el-option
                            v-for="(item, index) in stores"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Common.date')">
                    <el-date-picker
                        v-model="form.date"
                        type="date"
                        style="width: 180px"
                        :placeholder="$t('Common.choose_date2')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Contract.type')">
                    <el-select
                        v-model="form.contractType"
                        style="width: 180px;"
                        :placeholder="$t('Choose.contract_type')">
                        <el-option
                            v-for="(item, index) in types"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Stats.Balanc.opera')">
                    <el-radio-group v-model="form.operation">
                        <el-radio :label="1">{{ $t('Stats.Revenue.income') }}</el-radio>
                        <el-radio :label="2">{{ $t('Stats.Revenue.out') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Stats.Balanc.amt')" prop="amount">
                    <el-input
                        type="number"
                        :min="1"
                        v-model.number="form.amount"
                        style="width: 180px;"
                        :placeholder="$t('Stats.Balanc.choose_amt')" />
                        {{ $t('Reception.Fifth.yuan') }}
                </el-form-item>
                <el-form-item :label="$t('Sell.Pay.title')">
                    <el-select
                        v-model="form.payMethod"
                        style="width: 180px;"
                        :placeholder="$t('Sell.Pay.methods')">
                        <el-option
                            v-for="(item, index) in options"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')" prop="remark">
                    <el-input
                        :placeholder="$t('Common.remark_placeholder')"
                        type="textarea"
                        v-model="form.remark" />
                </el-form-item>
            </el-form>
            <div style="margin-left: 120px;" class="mt-10">
                <el-button
                    @click="submit()"
                    type="primary"
                >{{ $t('Stats.Balanc.confirm_add') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            visible: false,
            options: [
                {
                    code: 1,
                    name: this.$t('Sell.Pay.cash'),
                }, {
                    code: 2,
                    name: this.$t('Sell.Pay.swipe'),
                }, {
                    code: 3,
                    name: this.$t('Sell.Pay.bank'),
                }, {
                    code: 4,
                    name: this.$t('Sell.Pay.alipay'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Pay.wechat'),
                }, {
                    code: 8,
                    name: this.$t('Sell.Pay.other'),
                },
            ],
            form: {
                storeId: null,
                date: new Date(),
                contractType: 1,
                amount: null,
                payMethod: 1,
                remark: null,
                operation: 1,
            },
            rules: {
                amount: { required: true, message: this.$t('Stats.Balanc.fill_amt') },
                remark: { required: true, message: this.$t('Stats.Balanc.required') },
            },
            stores: [],
            types: [],
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        handleType() {
            API.get('constant/contract').then(res => {
                this.types = res.contractType;
            });
        },
        resetForm() {
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(data) {
            this.visible = true;
            this.fetchStore();
            this.handleType();
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = res[0].id;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            form.date = form.date.format('YYYY-MM-DD');
            API.post('statistic/revenue/balance', form).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.flat-account-components {
    .el-dialog {
        width: 710px;
    }
}
</style>
